'use strict';

function formatCzSkPostalCode(postalCodeInput) {
    var val = postalCodeInput.value.replace(/\D/g, '');
    if (val.length > 3) {
        val = val.slice(0, 3) + ' ' + val.slice(3, 5);
    }
    postalCodeInput.value = val;
}

function addParsleyValidator () {
    window.Parsley.addValidator('postcodeValidation', {
        validateString: function (currentPostalCode, _requirement, parsleyInstance) {
            var excludedPostalCodes = $('input[name="dwfrm_shipping_shippingAddress_shippingMethodID"]:checked').attr('data-excluded-postal-codes');
            var config = [];

            if (!currentPostalCode) {
                return true;
            }

            if (excludedPostalCodes) {
                try {
                    config = JSON.parse(excludedPostalCodes);
                } catch (e) {
                    config = [];
                }
            }

            if (!Array.isArray(config) || config.length === 0) {
                return true;
            }

            var isBlocked = config.some(function (code) {
                return String(code) === String(currentPostalCode);
            });

            return !isBlocked;
        }
    });
}

function init () {
    addParsleyValidator();

    $('body').on('change input', '#shippingZipCode', function () {
        $(this).parsley().validate();
    });

    $('body').on('change', 'input[name$="_shippingMethodID"]', function () {
        $('#shippingZipCode').parsley().validate();
    });

    $('body').on('input', '#shippingZipCode', function () {
        var country = $('select.shippingCountry').val();
        if (country === 'CZ' || country === 'SK') {
            formatCzSkPostalCode(this);
        }
    });

    $('body').on('input', '#billingZipCode', function () {
        var country = $('.billingCountry').val();
        if (country === 'CZ' || country === 'SK') {
            formatCzSkPostalCode(this);
        }
    });
}

module.exports = {
    init: init
};
